<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="structure-sub">Contents<span class="normal-caps2"></span></p>
<p class="link"><a id="a1"></a><a href="#/OEBPS/RealLifeOrg_split_004#b1">Foreword by Bestselling Author Peter Walsh</a><span class="normal-caps"></span></p>
<p class="link"><a id="a2"></a><a href="#/OEBPS/RealLifeOrg_split_007#b2">Introduction</a></p>
<p class="basic-paragraph"><span class="normal-caps"> </span></p>
<p class="link1"><a id="a3"></a><a href="#/OEBPS/RealLifeOrg_split_011#b3">What ClutterBug are You?</a><span class="normal-caps"></span></p>
<p class="link1"><a id="a4"></a><span href="#/OEBPS/RealLifeOrg_split_019#b4" title="Link target outside of Sample">15 Minutes a Day Keeps the Clutter Away</span><span class="normal-caps"></span></p>
<p class="link1"><a id="a5"></a><span href="#/OEBPS/RealLifeOrg_split_024#b5" title="Link target outside of Sample">Painless Purging with the 21 Item Toss </span><span class="normal-caps"></span></p>
<p class="link1"><a id="a6"></a><span href="#/OEBPS/RealLifeOrg_split_029#b6" title="Link target outside of Sample">Find the Valuable Real Estate in Your Home</span><span class="normal-caps"></span></p>
<p class="link1"><a id="a7"></a><span href="#/OEBPS/RealLifeOrg_split_031#b7" title="Link target outside of Sample">Contain the Clutter - The Secret to Organization</span><span class="normal-caps"></span></p>
<p class="link1"><a id="a8"></a><span href="#/OEBPS/RealLifeOrg_split_042#b8" title="Link target outside of Sample">The Burden of Guilty Clutter</span><span class="normal-caps"></span></p>
<p class="link1"><a id="a10"></a><span href="#/OEBPS/RealLifeOrg_split_044#b9" title="Link target outside of Sample">Routines, To-Dos and Checklists - Oh My!</span><span class="normal-caps"></span></p>
<p class="link1"><a id="a11"></a><span href="#/OEBPS/RealLifeOrg_split_049#b10" title="Link target outside of Sample">My Favorite Organizing Tips</span><span class="normal-caps"></span></p>
<p class="link1"><a id="a12"></a><span href="#/OEBPS/RealLifeOrg_split_051#b11" title="Link target outside of Sample">Organizing for Small Children</span><span class="normal-caps"></span></p>
<p class="link1"><a id="a13"></a><span href="#/OEBPS/RealLifeOrg_split_056#b12" title="Link target outside of Sample">Bloom Where You are Planted</span></p>
<p class="basic-paragraph"><span class="normal-caps"> </span></p>
<p class="link"><a id="a14"></a><span href="#/OEBPS/RealLifeOrg_split_061#Conclusion" title="Link target outside of Sample">Conclusion</span><span class="normal-caps"></span></p>
<p class="link"><a id="a15"></a><span href="#/OEBPS/RealLifeOrg_split_063#b13" title="Link target outside of Sample">Acknowledgements </span><span class="normal-caps"></span></p>
<p class="link"><a id="a16"></a><span href="#/OEBPS/RealLifeOrg_split_065#b14" title="Link target outside of Sample">Planner</span><span class="normal-caps"></span></p>
<div class="calibre2" id="calibre_pb_2"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RealLifeOrg_split_002.vue?7febd8a3